/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { BlueShiftEvents } from "./events";
const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? 0 + minutes : minutes;
    const strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
};
const getDateMeta = (date) => ({
    time: formatAMPM(date),
    date: date.getDate(),
    dayOfWeek: date.toLocaleDateString("en-in", { weekday: "long" }),
});
const sendBlueshiftData = (event, payLoad) => {
    const blueshift = window.blueshift || [];
    return blueshift.track(event, payLoad);
};
export const initializeBlueshift = (userId, firstName, lastName, userPhoneNumber, userEmailId) => {
    const timeStamp = getDateMeta(new Date());
    const timeStampForAdobe = timeStamp.time + "|" + timeStamp.dayOfWeek + "|" + timeStamp.date;
    const blueshift = window.blueshift || [];
    blueshift.identify({
        customer_id: userId,
        email: userEmailId,
        phoneNumber: userPhoneNumber,
        joined_at: timeStampForAdobe,
        firstname: firstName,
        lastname: lastName,
    });
};
export const blueshiftAuthentication = (userId, isLoggedIn) => {
    const payLoad = {
        user_profile_id: userId,
        auth_login_status: isLoggedIn === true ? "logged-out" : "logged-in",
    };
    sendBlueshiftData(BlueShiftEvents.AUTHENTICATION, payLoad);
};
export const blueshiftEnvironmentData = (isLoggedIn, currentLocation, realm) => {
    const payLoad = {
        env_country_code: currentLocation,
        env_language_code: "en",
        env_version_number: "2.1.3",
        env_realm: realm,
        env_platform: "web",
        env_login_status: isLoggedIn === true ? "logged-out" : "logged-in",
        env_brand: "discoveryPlus",
    };
    sendBlueshiftData(BlueShiftEvents.ENVIRONMENT, payLoad);
};
export const blueshiftPageView = (id, pageUrl, pageAlias, pageTitle, previousPageUrl) => {
    const payLoad = {
        page_id: id,
        page_type: "page",
        page_route: pageUrl,
        page_alias: pageAlias,
        page_name: pageTitle,
        component_id: "",
        component_template_id: "",
        page_title: "",
        page_previous: previousPageUrl,
    };
    sendBlueshiftData(BlueShiftEvents.PAGE_LOADED, payLoad);
};
export const blueshiftFavorite = (userId, id, actionType, itemType, itemName, genres) => {
    const payload = {
        favourite_action: actionType,
        item_type: itemType,
        item_id: id,
        item_name: itemName,
        customer_id: userId,
        category: genres,
    };
    return sendBlueshiftData(BlueShiftEvents.FAVORITE, payload);
};
export const blueshiftContentImpressionEvent = (userId, category, id, primaryChannelTitle, alternateId, analyticsId, showTitle, type, seasonNum, episodeNum, episodeTitle, genres) => {
    const showDetailsPayLoad = {
        product_id: id,
        content_primary_channel: primaryChannelTitle,
        content_alternate_id: alternateId,
        content_analytics_id: analyticsId,
        content_show: showTitle,
        content_type: type,
        customer_id: userId,
        category: genres,
    };
    const videoPayLoad = {
        content_season_no: seasonNum,
        content_episode_no: episodeNum,
        content_episode_title: episodeTitle,
        category: genres,
    };
    const videoDetailsPayLoad = Object.assign(Object.assign({}, showDetailsPayLoad), videoPayLoad);
    const payLoad = category === "show" ? showDetailsPayLoad : videoDetailsPayLoad;
    sendBlueshiftData(BlueShiftEvents.CONTENT_IMPRESSION, payLoad);
};
export const blueshiftAdImpression = (userId, adId, adName, adPosition, adContentType) => {
    const payload = {
        customer_id: userId,
        ad_id: adId,
        ad_name: adName,
        ad_length: 0,
        ad_position: adPosition,
        ad_contentType: adContentType,
    };
    return sendBlueshiftData(BlueShiftEvents.AD_IMPRESSION, payload);
};
export const blueshiftClickEvent = (moduleName, parentTitle, parentPosition, childTitle, targetUrl, userId) => {
    const payLoad = {
        name: moduleName,
        parent_title: parentTitle,
        parent_position: parentPosition,
        child_title: childTitle,
        child_position: 1,
        targetUrl: targetUrl,
        customer_id: userId,
    };
    sendBlueshiftData(BlueShiftEvents.CLICK, payLoad);
};
